import FaqRoute from "./faq";

// Conduct is effectively a faq alias
export default class ConductRoute extends FaqRoute {
  pageId = "conduct";
}
